/**
 * Utility to gather browser/client context information
 */

interface ClientContext {
  browser: string;
  timezone: string;
  timestamp: string;
  timestamp_local: string;
  locale: string;
  platform: string;
  screenResolution: string;
  userAgent: string;
}

/**
 * Detects the browser name from user agent
 */
function detectBrowser(userAgent: string): string {
  if (
    userAgent.includes('Chrome') &&
    !userAgent.includes('Chromium') &&
    !userAgent.includes('Edg')
  ) {
    return 'Chrome';
  } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    return 'Safari';
  } else if (userAgent.includes('Firefox')) {
    return 'Firefox';
  } else if (userAgent.includes('Edg')) {
    return 'Edge';
  } else if (userAgent.includes('Opera') || userAgent.includes('OPR')) {
    return 'Opera';
  } else {
    return 'Unknown';
  }
}

/**
 * Gathers client context information from the browser
 */
export function getClientContext(): ClientContext {
  // Safely get values with fallbacks
  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : 'Unknown';
  const now = new Date();

  return {
    browser: detectBrowser(userAgent),
    timezone:
      typeof Intl !== 'undefined' && Intl.DateTimeFormat
        ? Intl.DateTimeFormat().resolvedOptions().timeZone
        : 'UTC',
    timestamp: now.toISOString(),
    timestamp_local: now.toLocaleString(),
    locale: typeof navigator !== 'undefined' && navigator.language ? navigator.language : 'en-US',
    platform:
      typeof navigator !== 'undefined' && navigator.platform ? navigator.platform : 'Unknown',
    screenResolution:
      typeof window !== 'undefined' && window.screen
        ? `${window.screen.width}x${window.screen.height}`
        : 'Unknown',
    userAgent: userAgent,
  };
}
